import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Fetches the current active calendar product and renders a promo banner
// linking to its sales page. Renders nothing if no calendar is active —
// safe to drop into any post regardless of whether a calendar exists yet.
function CalendarPromoBanner() {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    axios.get('/calendar-products')
      .then((res) => setProduct(res.data[0] || null))
      .catch(() => setProduct(null));
  }, []);

  if (!product) return null;

  return (
    <Link
      to="/shop/calendar"
      data-testid="calendar-promo-banner"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        textDecoration: 'none',
        color: 'inherit',
        background: '#faf8f5',
        border: '1px solid #eee',
        borderRadius: '10px',
        padding: '16px',
        margin: '40px 0'
      }}
    >
      <img
        src={product.image_url}
        alt={product.title}
        style={{ width: '90px', height: '90px', objectFit: 'cover', borderRadius: '6px', flexShrink: 0 }}
      />
      <div>
        <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#7c3aed', fontWeight: '600', marginBottom: '4px' }}>
          {product.pre_sale ? 'Now Taking Pre-Orders' : 'Now Available'}
        </div>
        <div style={{ fontSize: '17px', fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
          {product.title}
        </div>
        <div style={{ fontSize: '14px', color: '#666' }}>
          ${product.price.toFixed(2)} — Shop Now →
        </div>
      </div>
    </Link>
  );
}

export default CalendarPromoBanner;
